import { useContext } from 'react';

import { Radio } from '../../../../../components/radio';
import { PortfolioManagementContext } from '../../../../../providers/portfolio-management';
import './styles.scss';

export const PortfolioSidebarSettingsGeneral = () => {
  const { generalSettingsSelected, setGeneralSettingsSelected } = useContext(
    PortfolioManagementContext,
  );

  const handleSettingsGeneralAccountListingChange = (option: string) => {
    setGeneralSettingsSelected((state: any) => ({ ...state, accountListing: option }));
  };

  return (
    <div className="portfolio-sidebar-settings-general-container">
      <div className="portfolio-sidebar-settings-general-header">
        <h2>General settings</h2>
      </div>

      <div className="portfolio-sidebar-settings-general-selects">
        <div className="portfolio-sidebar-settings-general-selects-item">
          <span>Account listing</span>

          <div className="portfolio-sidebar-settings-general-selects-item-radios">
            <Radio
              label="By exchange"
              checked={generalSettingsSelected.accountListing === 'byExchange'}
              onChange={() => handleSettingsGeneralAccountListingChange('byExchange')}
            />
            <Radio
              label="Alphabetically"
              checked={generalSettingsSelected.accountListing === 'alphabetic'}
              onChange={() => handleSettingsGeneralAccountListingChange('alphabetic')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
